/**
 *
 * 瑞云请求集合
 * 已包含请求规则和加密实现
 */


((env = 'main') => {
  // const role = Shopify.theme.role
  const isTestEnv = () => env === "test";

  const fscloudDomain = isTestEnv()
    ? "https://apeu1-open.fscloud.com.cn/t/suuntotest/open/"
    : "https://apeu1-open.fscloud.com.cn/t/suunto/open/";

  const fscloudAssetsHost = isTestEnv()
    ? "https://apeu1-open.fscloud.com.cn/t/suuntotest/"
    : "https://apeu1-open.fscloud.com.cn/t/suunto/";

  // 签名密钥
  const secretKey = isTestEnv()
    ? "lhYFCNwvGEFkBICsuvbsPZvS7eyv6RmDLyO0bG3F"
    : "K6X7CgWpueRLc9paLUCaK5JnAxgv62UrGIOimW2q";

  // 固定参数
  const getRequiredParams = () => ({
    $tenant: isTestEnv() ? "suuntotest" : "suunto", // 租户名($tenant)
    $timestamp: getCurrentTimestamp(), // 时间戳($timestamp)
    $reqid: generateRandomString(), // 请求id($reqid)
    $appid: "suntuo_wss", // 应用id($appid)
  });

  // 获取当前语言类型
  const getLanguageType = (type) => {
    const languageMap = {
      'en': 'en-US',
      'zh': 'zh-CN'
    }
    return languageMap[type] ?? languageMap['en']
  }

  /**
   * 瑞云服务
   * 导出 fscloud 到 window
   */
  window.fscloud = {
    fscloudAssetsHost,
    /**
     * 获取寄修订单列表
     */
    getRepairOrders({ $pageindex = 1, $pagesize = 5, ...others } = {}) {
      const requiredParams = getRequiredParams();
      // 烘焙请求url
      const url = `${fscloudDomain}api/dynamic/new_depotrepair?${new URLSearchParams(
        { $pageindex, $pagesize, ...others, ...requiredParams }
      )}&$sign=${getSignature(secretKey, {
        $pageindex,
        $pagesize,
        ...others,
        ...requiredParams,
      })}`;
      return fetch(url, {
        headers: {
          "Accept-Language": getLanguageType(window.Shopify.locale)
        }
      })
        .then((response) => response.json())
        .catch((err) => {
          return err;
        });
    },

    /**
     * 获取签名api
     * params 请求参数
     *
     */

    async fetchServer(api, params = {}, options = { method: "GET" }) {
      options.headers = {
        ...options.headers,
        "Accept-Language": getLanguageType(window.Shopify.locale)
      }
      const requiredParams = getRequiredParams();
      let queryParams = { ...requiredParams };
      if (options?.method == "POST") {
        options["body"] =
          params instanceof FormData ? params : JSON.stringify(params);
      } else {
        queryParams = { ...requiredParams, ...params };
      }
      const sign = getSignature(secretKey, { ...queryParams });

      const url = `${fscloudDomain}${api}?${new URLSearchParams(
        queryParams
      )}&$sign=${sign}`;

      return fetch(url,
        { ...options }

      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`请求失败: ${response.status}`);
          }
          return response.json();
        })
        .catch((error) => {
          throw error;
        });
    },

    /**
     * 创建寄修单
     */
  };

  function getSignature(secretKey, pairs) {
    const stringA = urlRequestParameter(pairs);
    const stringSignTemp = jointSecretKey(stringA, secretKey);
    const sign = sha256EncryptString(stringSignTemp);
    return sign;
  }

  /**
   * Concatenates all request parameters in ascending order of parameter name, ignoring empty values.
   * @param {Object} obj - URL parameters
   * @returns {string} - Concatenated string
   */
  function urlRequestParameter(obj) {
    return Object.keys(obj)
      .sort() // Sort keys alphabetically
      .map((key) => obj[key]) // Get values
      .filter((value) => value) // Filter out empty values
      .join(""); // Concatenate values
  }

  /**
   * Appends secret key to stringA to form stringSignTemp.
   * @param {string} stringA - Concatenated parameter string
   * @param {string} secretKey - Secret key
   * @returns {string} - Concatenated string
   */
  function jointSecretKey(stringA, secretKey) {
    return stringA + secretKey;
  }

  /**
   * Encrypts stringSignTemp using SHA-256 and returns the result in uppercase.
   * @param {string} data - Concatenated string
   * @returns {string} - Encrypted string
   */
  function sha256EncryptString(data) {
    return sha256(data).toUpperCase();
  }

  /**
   * Generates a random UUID (Version 4).
   * @returns {string} - Random UUID
   */
  function generateRandomString() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  /**
   * Returns the current timestamp in milliseconds.
   * @returns {number} - Current timestamp
   */
  function getCurrentTimestamp() {
    return Date.now();
  }

  /**
   * SHA-256 encryption algorithm implementation.
   * @param {string} message - Input string to be hashed
   * @returns {string} - SHA-256 hash of the input string
   */
  function sha256(message) {
    function rightRotate(n, x) {
      return (x >>> n) | (x << (32 - n));
    }

    const K = new Uint32Array([
      0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1,
      0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
      0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174, 0xe49b69c1, 0xefbe4786,
      0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
      0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147,
      0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
      0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85, 0xa2bfe8a1, 0xa81a664b,
      0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
      0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a,
      0x5b9cca4f, 0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
      0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2,
    ]);

    function sha256(message) {
      const blocks = prepareBlocks(message);
      const H = new Uint32Array([
        0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c,
        0x1f83d9ab, 0x5be0cd19,
      ]);

      for (let block of blocks) {
        const words = new Uint32Array(64);

        for (let i = 0; i < 16; i++) {
          words[i] =
            (block[i * 4] << 24) |
            (block[i * 4 + 1] << 16) |
            (block[i * 4 + 2] << 8) |
            block[i * 4 + 3];
        }

        for (let i = 16; i < 64; i++) {
          const s0 =
            rightRotate(7, words[i - 15]) ^
            rightRotate(18, words[i - 15]) ^
            (words[i - 15] >>> 3);
          const s1 =
            rightRotate(17, words[i - 2]) ^
            rightRotate(19, words[i - 2]) ^
            (words[i - 2] >>> 10);
          words[i] = (words[i - 16] + s0 + words[i - 7] + s1) >>> 0;
        }

        let [a, b, c, d, e, f, g, h] = H;

        for (let i = 0; i < 64; i++) {
          const S1 =
            rightRotate(6, e) ^ rightRotate(11, e) ^ rightRotate(25, e);
          const ch = (e & f) ^ (~e & g);
          const temp1 = (h + S1 + ch + K[i] + words[i]) >>> 0;
          const S0 =
            rightRotate(2, a) ^ rightRotate(13, a) ^ rightRotate(22, a);
          const maj = (a & b) ^ (a & c) ^ (b & c);
          const temp2 = (S0 + maj) >>> 0;

          h = g;
          g = f;
          f = e;
          e = (d + temp1) >>> 0;
          d = c;
          c = b;
          b = a;
          a = (temp1 + temp2) >>> 0;
        }

        H[0] = (H[0] + a) >>> 0;
        H[1] = (H[1] + b) >>> 0;
        H[2] = (H[2] + c) >>> 0;
        H[3] = (H[3] + d) >>> 0;
        H[4] = (H[4] + e) >>> 0;
        H[5] = (H[5] + f) >>> 0;
        H[6] = (H[6] + g) >>> 0;
        H[7] = (H[7] + h) >>> 0;
      }

      const hash = new Uint8Array(32);
      for (let i = 0; i < 8; i++) {
        hash[i * 4] = (H[i] >>> 24) & 0xff;
        hash[i * 4 + 1] = (H[i] >>> 16) & 0xff;
        hash[i * 4 + 2] = (H[i] >>> 8) & 0xff;
        hash[i * 4 + 3] = H[i] & 0xff;
      }

      return Array.prototype.map
        .call(hash, (x) => ("00" + x.toString(16)).slice(-2))
        .join("");
    }

    function prepareBlocks(message) {
      const bytes = new Uint8Array(message.length);
      for (let i = 0; i < message.length; i++) {
        bytes[i] = message.charCodeAt(i);
      }

      const bitLength = bytes.length * 8;
      const extraLength =
        (bitLength + 1 + 64) % 512 === 0
          ? 0
          : (512 - ((bitLength + 1 + 64) % 512)) / 8;
      const totalLength = bytes.length + 1 + extraLength + 8;
      const result = new Uint8Array(totalLength);
      result.set(bytes);

      result[bytes.length] = 0x80;

      const lengthBytes = new DataView(new ArrayBuffer(8));
      lengthBytes.setBigUint64(0, BigInt(bitLength), false);
      for (let i = 0; i < 8; i++) {
        result[result.length - 8 + i] = lengthBytes.getUint8(i);
      }

      const blocks = [];
      for (let i = 0; i < result.length; i += 64) {
        blocks.push(result.subarray(i, i + 64));
      }

      return blocks;
    }
    const hash = sha256(message);
    return hash;
  }
})();
